import script from "./MarketplaceCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarketplaceCard.vue?vue&type=script&lang=ts&setup=true"

import "./MarketplaceCard.vue?vue&type=style&index=0&id=2f87dd18&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f87dd18"]])

export default __exports__